//
//
//
//
//
//
//

// import { parsePhoneNumber, isValidPhoneNumber } from "libphonenumber-js";
export default {
  name: "PhoneNumber",
  props: {
    "initialNumber": {
      type: String,
      default: null,
    },
    borderRadius: {
      type: Number,
      default: 5,
    },


  },
  data() {
    return {
      phoneNumber: null,
      borderRadiusData: this.borderRadius,
      // userLocation : this.getUserLocation ,
      countriesList: [
        "SA",
        "QA",
        "TR",
        "IQ",
        "KW",
        "BH",
        "AE",
        "YE",
        "JO",
        "DZ",
        "TN",
        "LY",
        "EG",
        "SD",
        "OM",
        "SY",
      ],
      translations: {
        countrySelectorLabel: "Country code",
        countrySelectorError: "Choose a country",
        phoneNumberLabel: "Phone number",
        example: "Example :",
      },
      results: {},
      disabled: false,
      hasLoaderActive: false,
      hasErrorActive: false,
    };
  },

  methods: {
    onUpdate(payload) {
      this.results = payload;
      this.$emit("choose-phone", this.results);
    },

    // getCountryCode() {
    //     if (isValidPhoneNumber(`${this.initialNumber}`,'TR')) {
    //         const result = parsePhoneNumber(`${this.initialNumber}`, 'TR')
    //         this.defaultCountry = result.country
    //         this.phoneNumber = result.nationalNumber
    //     }else {
    //         this.defaultCountry = 'TR'
    //         this.phoneNumber = this.initialNumber
    //     }
    // }

  },
  computed: {
    userLocation() {
      return this.$store.state.userLocation
    }
  },
  created() {
    this.translations.countrySelectorLabel = this.$i18n.t(
      "contactForm.phone.countryCode"
    );
    this.translations.countrySelectorError = this.$i18n.t(
      "contactForm.phone.chooseCountry"
    );
    this.translations.phoneNumberLabel = this.$i18n.t(
      "contactForm.phone.phoneNumberLabel"
    );
    this.translations.example = this.$i18n.t("contactForm.phone.example");
  },
};
